import { render, staticRenderFns } from "./GestionPointsCatalogue.vue?vue&type=template&id=5d427990&"
import script from "./GestionPointsCatalogue.vue?vue&type=script&lang=js&"
export * from "./GestionPointsCatalogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports